import FranchiseDetails from "../Component/FranchiseDetails";
import { connect } from 'react-redux';

import {
  editFieldOffice,
  updateFieldOffice,
  updateFieldAddOn,
  addFieldAlert,
  getFieldAlert,
  updateFieldAlert,
  getStandardCleaning,
  updateStandardCleaning,
  getIntialCleaning,
  addIntialCleaning,
  deleteIntialCleaning,
  loginWithStripe,
  loginWithQuickbook,
  loginCallbackQuickbook,
  getOptimorouteKey,
  updateOptimorouteKey,
  getCollectionDetail,
  getAddOnCollectionDetail,
  getDashboardStat,
  getCustomerMatrix,
  getCustomerMatrix_v1,
  getUserDetail,
  getAllZipCodes,
  saveArea,
  getAllInitialCleaningData,
  getNextTenDaysInitialCleaningData,
  clearError,
  updateCleaningField,
  getGeocodeAddress,
  getStaxKeys,
  updateStaxKeys,
  getPulseMKeys,
  updatePulseMKeys,
  getServiceNotificationKeys,
  updateServiceNotificationKeys
} from '../../../../Action';

const mapStateToProps = (state) => {
  let { EditFieldOffice, UpdateFranchise, AddonUpdated, NewFieldAlert,
    FieldAlertsGet, UpdateAlert, StandardCleaning, UpdatePriceMatrix,
    AddInitial, GetInitial, DeleteInitial, StripeLogin, QuickbookLogin, FranchiseOverview,
    OptimorouteKey, Settings, GoogleApi, StaxKeys, UpdateStaxKeys, PulseMKeys, UpdatePulseMKeys,
    ZipCodes, InitialCleaning,
    ServiceNotificationKeys, UpdateServiceNotificationKeys } = state;
  return {
    EditFieldOffice,
    UpdateFranchise,
    AddonUpdated,
    NewFieldAlert,
    FieldAlertsGet,
    UpdateAlert,
    StandardCleaning,
    UpdatePriceMatrix,
    AddInitial,
    GetInitial,
    DeleteInitial,
    StripeLogin,
    QuickbookLogin,
    OptimorouteKey,
    FranchiseOverview,
    Settings,
    ZipCodes,
    InitialCleaning,
    GoogleApi,
    StaxKeys,
    UpdateStaxKeys,
    PulseMKeys,
    UpdatePulseMKeys,
    ServiceNotificationKeys,
    UpdateServiceNotificationKeys
  }
}
const actionCreators = {
  editFieldOffice, updateFieldOffice,
  updateFieldAddOn, addFieldAlert, getFieldAlert,
  updateFieldAlert, getStandardCleaning, updateStandardCleaning,
  addIntialCleaning, getIntialCleaning, deleteIntialCleaning, loginWithStripe,
  loginWithQuickbook, loginCallbackQuickbook, getCollectionDetail, getAddOnCollectionDetail, getDashboardStat, getCustomerMatrix, updateOptimorouteKey,
  getAllZipCodes,
  saveArea,
  getAllInitialCleaningData,
  getNextTenDaysInitialCleaningData,
  updateCleaningField,
  clearError,
  getCustomerMatrix_v1, getOptimorouteKey, getUserDetail, getGeocodeAddress, getStaxKeys, updateStaxKeys, getPulseMKeys, updatePulseMKeys,
  getServiceNotificationKeys, updateServiceNotificationKeys
}
export default (connect(mapStateToProps, actionCreators)(FranchiseDetails));